/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Input } from '@airtel/air-design-system';
import QrScanner from 'qr-scanner';
import { useEffect, useRef, useState } from 'react';
import { Modal } from 'react-native';
import QRFrameImage from '../../assets/images/svg/qr-frame.svg';
import { getAttributesFromXML } from '../../utils/CommonUtils';
import '../image-modal/imageModalStyles.scss';
import './QRScannerModal.scss';
import { QrScannerProps, ScannerRef, VideoRef } from './QRScannerModalPropTypes';
import ModalCloseButton from '../modal-close-button';

const QRScanner: React.FC<QrScannerProps> = (props) => {
   const { visible, artistRef, errorState, setErrorState, setIsQRScannerModalOpen } = props;
   const scanner = useRef<ScannerRef>(null);
   const videoEl = useRef<VideoRef>(null);
   const [scannedResult, setScannedResult] = useState<string | undefined>('');
   const [isQRScanned, setIsQRScanned] = useState<boolean>(false);
   const onScanSuccess = (result: QrScanner.ScanResult) => {
      const actions = []
      actions.push({
         analyticsAction: 'click',
         analyticsData: {
            eventCategory: 'new_acq_postpaid_skyc_landing_page',
            section: 'step6',
            subSection: 'SimScannerWidget',
            eventAction: 'click',
            eventLabel: 'SIM Number scanned',
            eventValue: '',
            customValue: '',
            customLabel: 'button',
            prop35: '{{storeValues:orderData.orderData.cartId}}',
            extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
            prop45: '{{storeValues:appData.subJourney}}',
            eVar21: '{{storeValues:appData.loggedInNumber}}',
            eVar36: '{{storeValues:appData.msisdn}}',
            city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
            eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
            prop4: 'SKYC',
            extraData11: '{{storeValues:layoutContext.layout}}',
            prop9: '{{storeValues:appData.lob}}'
         },
      });

      try {
         const { simNo } =
            getAttributesFromXML(result?.data, 'PrintLetterBarcodeData') || {};
         if (simNo) {
            setScannedResult(simNo);
            setIsQRScanned(true);
            actions.push({
               analyticsAction: 'click',
               analyticsData: {
                  eventCategory: 'new_acq_postpaid_skyc_landing_page',
                  section: 'step6',
                  subSection: 'SimScannerWidget',
                  eventAction: 'click',
                  eventLabel: 'SIM Number scanned successfully',
                  eventValue: simNo,
                  customValue: '',
                  customLabel: 'button',
                  prop35: '{{storeValues:orderData.orderData.cartId}}',
                  extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
                  prop45: '{{storeValues:appData.subJourney}}',
                  eVar21: '{{storeValues:appData.loggedInNumber}}',
                  eVar36: '{{storeValues:appData.msisdn}}',
                  city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
                  eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
                  prop4: 'SKYC',
                  extraData11: '{{storeValues:layoutContext.layout}}',
                  prop9: '{{storeValues:appData.lob}}'
               },
            });
         } else {
            throw Error();
         }
      } catch (e: any) {
         onInvalidQR();
      } finally {
         artistRef?.current?.onUserAction({
            actions,
         });
      }
   };

   useEffect(() => {
      setErrorState('');
      if (isQRScanned && scannedResult && scannedResult.length === 20) {
         setIsQRScanned(false);
         onSubmitQRCode();
      }
   }, [scannedResult]);

   const onInputFilled = (e: any) => {
      const actions = [];
      actions.push(
         {
            payload: {
               eventData: {
                  'buttonData.leftCta.disabled': true,
               },
               shouldResolveData: true,
               eventName: 'AnchoredActionWidget',
            },
            actionWithDelayed: 0,
            type: 'nativeEventEmitter',
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'step6',
               subSection: 'SimScannerWidget',
               eventAction: 'click',
               eventLabel: 'enter sim number manually',
               eventValue: e?.target?.value,
               customValue: '',
               customLabel: 'button',
               prop35: '{{storeValues:orderData.orderData.cartId}}',
               extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
               prop4: 'SKYC',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop9: '{{storeValues:appData.lob}}'
            },
         }
      );
      artistRef?.current?.onUserAction({
         actions,
      });
   };

   const onInvalidQR = () => {
      const actions = [
         {
            type: 'showToast',
            payload: {
               title: 'Invalid QR code. Please scan again.',
               dismissDuration: 3000,
               position: 'bottom-center',
               state: 'error',
               style: {
                  zIndex: 10000,
               },
            },
         },
      ];
      artistRef?.current?.onUserAction({
         actions,
      });
   };

   const onSubmitQRCode = () => {
      const actions = [
         {
            type: 'apiCall',
            payload: {
               apiUrl: 'guardian/api/skyc/new/validate-and-fetch-circle/v1',
               authTokenGroup: 'SKYC_REVERIFICATION',
               requestType: 'POST',
               body: {
                  lob: '{{storeValues:appData.lob}}',
                  circleId: '{{storeValues:pincodeContext.pincodeDetails.circleId}}',
                  msisdn: '{{storeValues:numberContext.selectedNumber}}',
                  simNo: scannedResult,
                  listOfSims: '{{storeValues:simSelectionContext.listOfSims}}',
                  isMnp: '{{storeValues:appData.orderSubType}}',
                  upcCode: '{{storeValues:portingContext.upcCode}}',
                  upcGeneratedDate: '{{storeValues:portingContext.upcGeneratedDate}}'
               },
            },
         },
         {
            analyticsAction: 'click',
            analyticsData: {
               eventCategory: 'new_acq_postpaid_skyc_landing_page',
               section: 'step6',
               subSection: 'SimScannerWidget',
               eventAction: 'click',
               eventLabel: 'submit',
               eventValue: scannedResult,
               customValue: '',
               customLabel: 'button',
               prop35: '{{storeValues:orderData.orderData.cartId}}',
               extraData12: '{{storeValues:orderData.orderData.cartItemId}}',
               prop45: '{{storeValues:appData.subJourney}}',
               eVar21: '{{storeValues:appData.loggedInNumber}}',
               eVar36: '{{storeValues:appData.msisdn}}',
               city: '{{storeValues:pincodeContext.pincodeDetails.city}}',
               eVar25: '{{storeValues:pincodeContext.pincodeDetails.circleName}}',
               prop4: 'SKYC',
               extraData11: '{{storeValues:layoutContext.layout}}',
               prop9: '{{storeValues:appData.lob}}'
            },
         },
         {
            "payload": {
               "context": "simNumberContext"
            },
            "type": "removeValuesInRedux"
         },
         {
            "payload": {
               "context": "numberContext"
            },
            "type": "removeValuesInRedux"
         },
         {
            "payload": {
               "context": "planInfo"
            },
            "type": "removeValuesInRedux"
         },
         {
            "payload": {
               "context": "allocatedContext"
            },
            "type": "removeValuesInRedux"
         },
         {
            "payload": {
               "context": "portingContext"
            },
            "type": "removeValuesInRedux"
         }
      ];

      artistRef?.current?.onUserAction({
         actions,
      });
   };

   useEffect(() => {
      (async () => {
         if (videoEl?.current && !scanner.current && visible) {
            const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
            scanner.current = new QrScanner(videoEl?.current, onScanSuccess, {
               preferredCamera: 'environment',
               calculateScanRegion(video) {
                  return {
                     x: 0,
                     y: 0,
                     width: video.width,
                     height: video.height,
                  };
               },
               highlightScanRegion: true,
               highlightCodeOutline: true,
            });
            if (!isIOS) {
               const listOfCameras = await QrScanner.listCameras(true)
               const selectedCameras: any = listOfCameras.filter(item => {
                  if (((item.label).toLowerCase().includes('back') || (item.label).toLowerCase().includes('rear')) && !((item.label).toLowerCase().includes('wide') || (item.label).toLowerCase().includes('telephoto'))) {
                     return item
                  }
               });
               if (selectedCameras.length > 1) {
                  const mainCamera = selectedCameras[selectedCameras.length - 1];
                  scanner?.current.setCamera(mainCamera?.id)
               }
            }
            scanner?.current.start();
         }
      })();

      // Cleanup function to stop the scanner when the component unmounts
      return () => {
         if (scanner.current) {
            scanner.current.stop();
            scanner.current = null;
         }
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [visible]);

   const updateScannedResult = (value: string) => {
      setIsQRScanned(false);
      setScannedResult(value);
   }

   return (
      <Modal visible={visible} animationType="slide" transparent={false}>
         <ModalCloseButton onPress={setIsQRScannerModalOpen} />
         <div id="qr-reader" className="outer-container">
            <div className='qr-scanner-container'>
               <video
                  autoPlay
                  playsInline
                  // style={{
                  //    transform: "scale(2)",
                  //    transformOrigin: "center"
                  // }}
                  ref={videoEl}
               />
               <img src={QRFrameImage} alt="frame" />
               {scannedResult && scannedResult.length === 20 && <div className='sim-scan-success'></div>}
            </div>
            <div className={scannedResult ? "btn-container-2" : "btn-container"}>
               <Input
                  value={scannedResult}
                  label="SIM Number"
                  state={errorState ? 'error' : 'none'}
                  hintText={
                     errorState ? errorState : 'You can find it on the SIM packet.'
                  }
                  containerStyle={{
                     width: '100%',
                  }}
                  variantStyle={scannedResult ? 'withLabel': 'default'}
                  size={scannedResult ? 'lg' : 'md'}
                  onChangeText={(e) => {updateScannedResult(e)}}
                  onBlur={onInputFilled}
                  autoFocus={false}
               />
               {scannedResult && (
                  <Button
                     style={{
                        marginTop: 20,
                     }}
                     title="Submit"
                     buttonType="primary"
                     size="md"
                     version="variable-width"
                     onPress={onSubmitQRCode}
                     disabled={
                        !scannedResult || scannedResult.length !== 20 || !!errorState
                     }
                  />
               )}
            </div>
         </div>
      </Modal>
   );
};

export default QRScanner;
